import { sendNumber } from '@/services/insuranceCard';

export const state = {
  insuranceCardInfo: null
};

export const mutations = {
  setInsuranceCardInfo(state, infos) {
    state.insuranceCardInfo = infos;
  }
};

export const actions = {
  sendNumber({ commit }, { insuranceCardNumber, expirationDate }) {
    return new Promise((resolve, reject) => {
      sendNumber(insuranceCardNumber, expirationDate)
        .then((response) => {
          commit('setInsuranceCardInfo', response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
